import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { ApiKeyFormSchemaValues } from 'src/features/apiKeys/utils/formSchema';
import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { commonMessages } from 'src/utils/messages';

type ApiKeyFormProps = {
    form: UseFormReturn<ApiKeyFormSchemaValues>;
    onSubmit: (values: ApiKeyFormSchemaValues) => void;
};

function ApiKeyForm({ onSubmit, form }: ApiKeyFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<ApiKeyFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(commonMessages.name)}
            />
        </Form>
    );
}

export default ApiKeyForm;
